import { useState } from "react"
import { Breadcrumb } from "react-bootstrap"
import Skeleton from "react-loading-skeleton"
import { IndexTemplate, TableView } from "../../../commons/components"
import { Page } from "../../../commons/services/types"
import { vendedorPolicy } from "../policies"
import { useGetVendedoresQuery } from "../services/vendedoresApi"

export function VendedorIndex(){
  const [page, setPage] = useState<Page>({
    current: 1,
    size: 10
  })

  const buscar = useGetVendedoresQuery({
    page
  })
  const isRefetching = !buscar.isLoading && buscar.isFetching

  return <>
    <Breadcrumb>
      <Breadcrumb.Item active>Vendedores</Breadcrumb.Item>
    </Breadcrumb>
    <IndexTemplate
      policy={vendedorPolicy}
      page={page}
      total={buscar.currentData?.meta.totalRecords ?? -1}
      onPageChange={setPage}
      onRefetch={buscar.refetch}
      registerPath="registrar"
      renderView={()=>{
        return <TableView
          expectedLength={page.size}
          data={isRefetching ? undefined : buscar.currentData?.records}
          isLoading={buscar.isFetching}
          hasError={buscar.isError}
          renderHeaders={()=><tr>
            <th style={{width: 0}}>#</th>
            <th className="text-nowrap">C.I.</th>
            <th className="text-nowrap">Nombre y apellido</th>
            <th style={{width: 0}}></th>
          </tr>}
          renderRow={(item, index)=><tr key={item?.id || index}>
            <th scope="row">{(page.current - 1)*page.size + index + 1}</th>
            <td>{item ? item.numeroDocumento : <Skeleton />}</td>
            <td>{item ? item.nombreCompleto : <Skeleton />}</td>
            {/* <td>{item ? <RowOptions usuario={item} /> : null}</td> */}
          </tr>}
        />
      }}
    />
  </>
}